import styled from 'styled-components';
import ContentWrapper from 'gatsby-theme-pagebuilder/src/components/blocks/quote/content-wrapper';

export default styled(ContentWrapper)`
  p {
    font-family: ${({ theme }) => theme.standoutFontFamily};
    font-weight: 700;
    
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
      font-size: 3rem;
    }
  }
`;
